<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select v-model="search.mn" style="width: 7.8em" placeholder="请选择站点" clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <i-input prefix="ios-search" placeholder="输入设备名称查询" v-model="search.name"
          style="width: auto;margin-left: 1em" />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="站点：" prop="mn">
          <!-- change保存站点图片 -->
          <Select v-model="formValidate.mn" @on-change="writeImg" clearable>
            <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="设备编号：" prop="code">
          <i-input v-model="formValidate.code" placeholder="输入设备编号"></i-input>
        </FormItem>
        <FormItem label="设备类型：" prop="mold">
          <Select v-model="formValidate.mold" clearable>
            <Option v-for="item in deviceTypeList" :key="item.id" :value="item.key">{{ item.value }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称：" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入名称"></i-input>
        </FormItem>
        <FormItem label="主要设备：" prop="masterDevice">
          <RadioGroup v-model="formValidate.masterDevice">
            <Radio label="true">
              <span>主要设备</span>
            </Radio>
            <Radio label="false">
              <span>普通设备</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否参与告警：" prop="monitorDeviceState">
          <RadioGroup v-model="formValidate.monitorDeviceState">
            <Radio label="true">
              <span>参与</span>
            </Radio>
            <Radio label="false">
              <span>不参与</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="型号：" prop="type">
          <i-input v-model="formValidate.type" placeholder="输入型号"></i-input>
        </FormItem>
        <FormItem label="配图：" prop="imgUrl">
          <div class="form_upload">
            <LoadImg :imgUrl="formValidate.imgUrl" @close="imgLoadDel" @success="imgLoadSuccess($event)"></LoadImg>
          </div>
        </FormItem>
        <!-- 新增 基数范围 -->
        <FormItem label="基数范围：">
          <Row>
            <i-col span="11">
              <i-input v-model="formValidate.aiExpressionEntity.a" placeholder="输入最小值"></i-input>
            </i-col>
            <i-col span="2">
              <div style="width:100%;text-align:center">-</div>
            </i-col>
            <i-col span="11">
              <i-input v-model="formValidate.aiExpressionEntity.b" placeholder="输入最大值"></i-input>
            </i-col>
          </Row>
        </FormItem>
        <FormItem label="设置位置：">
          <i-button @click="openSiteImg">打开工艺图</i-button>
        </FormItem>
        <FormItem label="x坐标：" prop="imgUrlX">
          <i-input v-model="formValidate.imgUrlX" placeholder="输入x坐标"></i-input>
        </FormItem>
        <FormItem label="y坐标：" prop="imgUrlY">
          <i-input v-model="formValidate.imgUrlY" placeholder="输入y坐标"></i-input>
        </FormItem>
        <FormItem label="图片宽度：" prop="imgUrlWidth">
          <i-input v-model="formValidate.imgUrlWidth" placeholder="输入图片宽度"></i-input>
        </FormItem>
        <FormItem label="图片高度：" prop="imgUrlHeight">
          <i-input v-model="formValidate.imgUrlHeight" placeholder="输入图片高度"></i-input>
        </FormItem>
        <FormItem label="品牌：" prop="brand">
          <i-input v-model="formValidate.brand" placeholder="输入品牌"></i-input>
        </FormItem>
        <FormItem label="数量：" prop="amount">
          <i-input v-model="formValidate.amount" placeholder="输入数量"></i-input>
        </FormItem>
        <FormItem label="电流放大倍数：" prop="magnify">
          <i-input v-model="formValidate.magnify" placeholder="输入放大比率"></i-input>
        </FormItem>
        <FormItem label="详情介绍：" prop="remark">
          <i-input v-model="formValidate.remark" placeholder="详情介绍"></i-input>
        </FormItem>
        <FormItem label="联系人：">
          <i-input v-model="formValidate.linkName" placeholder="输入联系人"></i-input>
        </FormItem>
        <FormItem label="联系方式：">
          <i-input v-model="formValidate.linkMobile" placeholder="输入联系方式"></i-input>
        </FormItem>
        <FormItem label="联系人部门：">
          <i-input v-model="formValidate.linkSection" placeholder="输入联系人部门"></i-input>
        </FormItem>
        <FormItem label="保修截止日期：">
          <DatePicker type="date" placeholder="选择保修截止日期" v-model="formValidate.warrantyDate"></DatePicker>
        </FormItem>

        <!-- <FormItem label="是否开启维保：">
          <i-switch @on-change="openMaintenance($event)">
            <span slot="open">开</span>
            <span slot="close">关</span>
          </i-switch>
        </FormItem>-->
        <FormItem label="上次维保日期：" v-show="MaintenanceFlag">
          <DatePicker type="date" placeholder="选择保上次维保日期" v-model="formValidate.maintenanceDate"></DatePicker>
        </FormItem>
        <FormItem label="维保周期：" v-show="MaintenanceFlag">
          <Select v-model="formValidate.maintenanceTimeExpression" clearable>
            <Option v-for="item in MaintenanceList" :value="item.type" :key="item.type">{{ item.date }}</Option>
          </Select>
        </FormItem>
        <FormItem label="排放限值：">
          <i-input v-model="formValidate.limitValue" placeholder="输入排放限值"></i-input>
        </FormItem>
        <FormItem label="数值单位">
          <i-input v-model="formValidate.unit" placeholder="输入设备数值对应的单位"></i-input>
        </FormItem>
        <arrowEdit ref="arrowRef"></arrowEdit>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 工艺图对话框 -->
    <Modal title="厂区工艺图" v-model="modal.companyShow" :mask-closable="false" width="832">
      <div class="content">
        <img :src="siteImgUrl" v-if="siteImgUrl" alt />
        <div v-if="!siteImgUrl">请先选择站点</div>
      </div>
    </Modal>
    <!-- 告警规则 -->
    <WarnRule ref="warnRule"></WarnRule>
    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";
import WarnRule from "../warnBind.vue";
import arrowEdit from './arrowEdit';

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "编号",
            key: "code",
            width: 80,
            align: "center"
          },
          {
            title: "站点名称",
            align: "center",
            render: (h, params) => {
              return h("span", {}, this.getSiteName(params.row.mn));
            }
          },
          {
            title: "工艺图",
            key: "picUrl",
            align: "center",
            render(h, params) {
              return h(
                "div",
                {
                  style: {
                    height: "50px",
                    overflow: "hidden"
                  }
                },
                [
                  h("vImage", {
                    // attrs: {
                    //   src: params.row.imgUrl
                    // },
                    props: {
                      imgUrl: params.row.imgUrl
                    }
                  })
                ]
              );
            }
          },
          {
            title: "设备名称",
            key: "name",
            width: 160,
            align: "center"
          },
          {
            title: "型号",
            key: "type",
            align: "center"
          },
          {
            title: "品牌",
            key: "brand",
            align: "center"
          },
          {
            title: "联系人",
            key: "linkName",
            align: "center"
          },
          {
            title: "联系电话",
            key: "linkMobile",
            align: "center"
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h(
                "span",
                {},
                timeStamp(params.row.createDate, "yyyy-MM-dd")
              );
            }
          },
          {
            title: "保修截止日期",
            key: "warrantyDate",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.warrantyDate, "yyyy-MM-dd"))
              ]);
            }
          },

          {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$refs.warnRule.deviceId = params.row.id;
                        this.$refs.warnRule.getNowWarn();
                        this.$refs.warnRule.show = true;
                      }
                    }
                  },
                  "绑定"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        if (params.row.arrowVector) {
                          this.$refs.arrowRef.setArrowList(JSON.parse(params.row.arrowVector));
                        }
                        if (params.row.maintenanceDate) {
                          // 如果有上次维保日期，n那么开启维保
                          this.MaintenanceFlag = true;
                        } else {
                          this.MaintenanceFlag = false;
                        }
                        this.writeImg(params.row.mn); // 切换站点图片
                        this.formValidate = {
                          id: params.row.id,
                          mn: params.row.mn, // 站点编号
                          code: params.row.code, // 设备编号
                          name: params.row.name, // 设备名称
                          type: params.row.type, // 型号
                          imgUrl: params.row.imgUrl, // 设备图片
                          imgUrlX: params.row.imgUrlX, // 设备图片定位X
                          imgUrlY: params.row.imgUrlY, // 设备图片定位Y
                          imgUrlWidth: params.row.imgUrlWidth, // 设备图片定位宽
                          imgUrlHeight: params.row.imgUrlHeight, // 设备图片定位高
                          remark: params.row.remark, // 备注
                          brand: params.row.brand, // 设备品牌
                          amount: params.row.amount, // 设备数量
                          price: params.row.price, //
                          mold: params.row.mold, // 设备类型
                          linkName: params.row.linkName, // 联系人
                          linkMobile: params.row.linkMobile, // 联系方式
                          linkMobile: params.row.linkSection, // 联系人部门
                          warrantyDate: timeStamp(
                            params.row.warrantyDate,
                            "yyyy-MM-dd", true
                          ), // 保修截止日期
                          maintenanceTimeExpression:
                            params.row.maintenanceTimeExpression, // 维保周期
                          maintenanceDate: params.row.maintenanceDate, // 上次维保日期
                          aiExpressionEntity: params.row.aiExpressionEntity, // 基数范围如ph: 0 1
                          masterDevice: params.row.masterDevice + "", // 主要设备bool
                          monitorDeviceState: params.row.monitorDeviceState + "", // 参与告警设备bool
                          magnify: params.row.magnify + "", //电流变比
                          limitValue: params.row.limitValue,
                          unit: params.row.unit,
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        name: null, // 设备名
        mn: null // 站点编号
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加",
        companyShow: false // 站点工艺图modal显示隐藏
      },
      // 表单数据
      formValidate: {
        mn: "", // 站点编号
        code: "", // 设备编号
        name: "", // 设备名称
        type: "", // 型号
        imgUrl: "", // 设备图片
        remark: "", // 备注
        brand: "", // 设备品牌
        amount: "", // 设备数量
        price: "", //
        mold: "", // 设备类型
        imgUrlX: "", // 设备图片定位X
        imgUrlY: "", // 设备图片定位Y
        imgUrlWidth: "", // 设备图片定位宽
        imgUrlHeight: "", // 设备图片定位高
        warrantyDate: "", // 保修截止日期
        maintenanceTimeExpression: "", // 维保周期
        maintenanceDate: "", // 上次维保日期
        aiExpressionEntity: {
          // 计算基数 如ph: 0-14
          a: "", // 开始
          b: "" // 结束
        },
        linkName: "", // 联系人
        linkMobile: "", // 联系方式
        linkMobile: "", // 联系人部门
        masterDevice: null, // 是否是主要设备 true是主要设备
        monitorDeviceState: null, // 是否是不参与告警设备false不参与
        magnify: "", //电流变比
        limitValue: null, //排放限值
        unit: "", //单位
      },
      // 验证
      ruleValidate: {
        mn: [
          {
            required: true,
            message: "请选择",
            trigger: "change"
          }
        ],
        mold: [
          {
            required: true,
            message: "请选择",
            trigger: "change"
          }
        ],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        code: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrl: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrlY: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrlX: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrlWidth: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrlHeight: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
        brand: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ],
        amount: [{ required: true, message: "不能为空", trigger: "blur" }],
        price: [{ required: true, message: "不能为空", trigger: "blur" }],
        warrantyDate: [
          {
            required: true,
            type: "date",
            message: "请选择保修截止日期",
            trigger: "change"
          }
        ],
        masterDevice: [
          { required: true, message: "不能为空", trigger: "blur" }
        ], // 是否是主要设备 true是主要设备
        monitorDeviceState: [
          { required: true, message: "不能为空", trigger: "blur" }
        ] // 是否是不参与告警设备false不参与
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      siteList: [], //站点枚举
      deviceTypeList: [], // 设备类型枚举
      // 维保周期枚举
      MaintenanceList: [
        {
          date: "5天",
          type: "5天"
        },
        {
          date: "15天",
          type: "15天"
        },
        {
          date: "一个月",
          type: "1月"
        },
        {
          date: "两个月",
          type: "2月"
        },
        {
          date: "三个月",
          type: "3月"
        },
        {
          date: "半年",
          type: "6月"
        }
      ],
      // 是否启用维保字段
      MaintenanceFlag: false,
      // 站点图片
      siteImgUrl: null
    };
  },
  components: {
    toolbar,
    LoadImg,
    WarnRule,
    arrowEdit
  },
  async created() {
    await this.getSiteEnum();
    await this.getDeviceType();
    await this.getData(); // 数据初始化
  },
  methods: {
    addData() {
      // 打开表单添加
      this.$refs.arrowRef.setArrowList([]);
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        mn: "", // 站点编号
        code: "", // 设备编号
        name: "", // 设备名称
        type: "", // 型号
        imgUrl: "", // 设备图片
        imgUrlX: "", // 设备图片定位X
        imgUrlY: "", // 设备图片定位Y
        imgUrlWidth: "", // 设备图片定位宽
        imgUrlHeight: "", // 设备图片定位高
        remark: "", // 备注
        brand: "", // 设备品牌
        amount: "", // 设备数量
        price: "", //
        mold: "", // 设备类型
        warrantyDate: "", // 保修截止日期
        maintenanceTimeExpression: "", // 维保周期
        maintenanceDate: "", // 上次维保日期
        aiExpressionEntity: {
          // 计算基数 如ph: 0-14
          a: "", // 开始
          b: "" // 结束
        },
        linkName: "", // 联系人
        linkMobile: "", // 联系方式
        linkMobile: "", // 联系人部门
        masterDevice: null, // 是否是主要设备 true是主要设备
        monitorDeviceState: null, // 是否是不参与告警设备false不参与
        magnify: "", //电流变比
        limitValue: null,
        unit: "",
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    async getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getDeviceList_1(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getDeviceDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 处理尖头
          let list = this.$refs.arrowRef.getArrowList();
          params.arrowVector = JSON.stringify(list);
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postDeviceAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postDeviceEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取站点枚举值
    async getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取设备类型枚举
    async getDeviceType() {
      this.$api.Enum.getDeviceTypeEnum(
        { content: { tableName: "site_device", columnName: "type" } },
        ["uuid", "common"]
      ).then(res => {
        if (res.code == 0) {
          this.deviceTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取设备类型枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.imgUrl = url;
    },
    // 表单维保开关
    openMaintenance(flag) {
      this.formValidate.maintenanceTimeExpression = "";
      this.formValidate.maintenanceDate = "";
      this.MaintenanceFlag = flag;
    },
    // 站点改变后记录站点图片
    writeImg(mn) {
      // 遍历出站点图片
      let data = this.siteList;
      //console.log(data, mn);
      let imgUrl = data.filter(res => {
        if (res.mn == mn) return res.imgUrl;
      });
      if (imgUrl[0])
        this.siteImgUrl = imgUrl[0].imgUrl;
    },
    // 打开站点图编辑位置
    openSiteImg() {
      this.modal.companyShow = true;
    },
    // img删除回调
    imgLoadDel() {
      this.formValidate.imgUrl = null;
    },
    // 获取站点名称的方法
    getSiteName(mn) {
      // console.log('mn'+mn);
      // console.dir(this.siteList);
      // 使用 find 方法在 siteList 中查找与 mn 匹配的站点
      const site = this.siteList.find(site => site.mn === mn);
      // 如果找到站点则返回其名称，否则返回默认值
      return site ? site.name : "未知站点";
    },
  }
};
</script>